import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employees: [],
  tempEmployees: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
  dashboardStats: {
    totalEmployees: 0,
    fullTimeEmployees: 0,
    partTimeEmployees: 0,
    presentToday: 0,
    absentToday: 0,
    onLeaveToday: 0,
    totalMonthlySalary: 0,
    totalMonthlyWage: 0
  },
  todayAttendance: [],
};

const employeeSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    setEmployees(state, action) {
      state.employees = action.payload;
      state.isLoading = false;
    },
    setTempEmployees(state, action) {
      state.tempEmployees = action.payload;
    },
    setEmployeePagination(state, action) {
      state.pagination = action.payload;
    },
    addEmployee(state, action) {
      state.employees.push(action.payload);
      state.tempEmployees.push(action.payload);
    },
    updateEmployee(state, action) {
      const { index, employee } = action.payload;
      if (state.employees && index >= 0 && index < state.employees.length) {
        state.employees[index] = employee;
      }
      if (state.tempEmployees && index >= 0 && index < state.tempEmployees.length) {
        state.tempEmployees[index] = employee;
      }
    },
    deleteEmployeeItem(state, action) {
      const { index } = action.payload;
      if (index >= 0 && index < state.employees.length) {
        state.employees.splice(index, 1);
      }
      if (index >= 0 && index < state.tempEmployees.length) {
        state.tempEmployees.splice(index, 1);
      }
    },
    setEmployeeIsLoading(state, action) {
      state.isLoading = action.payload !== undefined ? action.payload : true;
    },
    setDashboardStats(state, action) {
      state.dashboardStats = action.payload;
    },
    setTodayAttendance(state, action) {
      state.todayAttendance = action.payload;
    },
    clearEmployeeDashboardData(state) {
      state.dashboardStats = initialState.dashboardStats;
      state.todayAttendance = [];
    },
  },
});

// Selectors for computed data
export const selectEmployeeDashboardStats = (state) => {
  const employees = state.employees.employees || [];
  const dashboardStats = state.employees.dashboardStats;
  
  // Calculate stats from employees data
  const fullTimeEmployees = employees.filter(e => 
    e.employeeType === 'full_time' || e.employeeType === 'full-time'
  ).length;
  
  const partTimeEmployees = employees.filter(e => 
    e.employeeType === 'part_time' || e.employeeType === 'part-time'
  ).length;

  const totalMonthlySalary = employees
    .filter(e => e.employeeType === 'full_time' || e.employeeType === 'full-time')
    .reduce((sum, e) => sum + (parseFloat(e.employeeSalary) || 0), 0);

  const totalMonthlyWage = employees
    .filter(e => e.employeeType === 'part_time' || e.employeeType === 'part-time')
    .reduce((sum, e) => sum + (parseFloat(e.wageAmount) || 0), 0);

  return {
    totalEmployees: employees.length,
    fullTimeEmployees,
    partTimeEmployees,
    totalMonthlySalary,
    totalMonthlyWage,
    presentToday: dashboardStats?.presentToday || 0,
    absentToday: dashboardStats?.absentToday || 0,
    onLeaveToday: dashboardStats?.onLeaveToday || 0,
    ...dashboardStats // Merge with any additional API stats
  };
};

export const {
  setEmployees,
  setTempEmployees,
  addEmployee,
  updateEmployee,
  deleteEmployeeItem,
  setEmployeePagination,
  setEmployeeIsLoading,
  setDashboardStats,
  setTodayAttendance,
  clearEmployeeDashboardData,
} = employeeSlice.actions;

export default employeeSlice.reducer;